import PropTypes from 'prop-types';
import { useCallback } from 'react';
import Helmet from 'react-helmet';
import { useParams } from 'react-router-dom';

import { DefaultSheet } from 'twyne-new.ui';

import { useAppAlert } from '@Components/AppAlert';
import app from '@Stores/app';
import history from 'utils/history';

import Form from '../components/Form';
import { SiteProvider, useSiteStore } from '../store';

const propTypes = {
  match: PropTypes.object,
}

const SiteForm = () => {
  const { id } = useParams()
  const { collection: { item, useLoad, useSubmit, reset } } = useSiteStore()
  const { handleSuccess, handleError } = useAppAlert()

  useLoad(id)
  const handleSubmit = useSubmit()

  const handleSidebarClose = useCallback(() => {
    history.push('/admin/sites')
    reset()
  }, [reset])

  const handleSubmitAndClose = useCallback(async payload => {
    try {
      await handleSubmit(payload)
      if (payload.id === app.currentSiteID) {
        app.setSite(payload)
      }
      handleSidebarClose()
      const message = payload.id ? 'edited' : 'created'
      handleSuccess('Success', `Site ${message}.`)
    } catch (error) {
      handleError('Error', 'Site was not saved.')
    }
  }, [handleSubmit, handleSidebarClose, handleSuccess, handleError]);

  if (!item) {
    return null
  }

  return <DefaultSheet
    wrapperProps={{ defaultOpen: true, onOpenChange: open => !open && handleSidebarClose() }}
    title={item.id ? 'Edit Site' : 'Add Site'}>
    <Helmet title="Site" />
    <Form data={item} onSubmit={handleSubmitAndClose} onClose={handleSidebarClose} />
  </DefaultSheet>
}

SiteForm.propTypes = propTypes
SiteForm.defaultProps = {}

export default function SiteFormLayout() {
  return <SiteProvider>
    <SiteForm />
  </SiteProvider>
}
